export const options = {
  style: {
    top: '9.7em',
    border: '1px solid #ccc',
    margin: '0 10px'
  },
  progressStyle: {
    background: '#CF8200'
  },
  position: 'top-center'
};
